import { TSortingParameter } from 'libs/ui/src/lib/listing-sorter/sorter.types';
import { TFilterSelected } from '../filter.types';
import { TPaginationInfo } from '../input-app/fabric-inspection/api.types';

export const E8_MASTER_NAMES = [
  'PRODUCT_TYPE',
  'OPERATION',
  'PART',
  'MACHINE',
  'STYLE_NO',
  'FATIGUE_ALLOWANCE',
] as const;
export type TE8MasterName = (typeof E8_MASTER_NAMES)[number];

export type TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS = {
  data: Pick<TRESPONSE_PRODUCT_TYPE_MASTER['data'][number], 'id' | 'code' | 'name'>[];
};

export type TAddNewMasterModalComponentProps = {
  inputProps:
    | { masterName: 'PRODUCT_TYPE' }
    | { masterName: 'MACHINE' }
    | { masterName: 'FATIGUE_ALLOWANCE' }
    | { masterName: 'OPERATION'; productTypes: TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS['data'] }
    | { masterName: 'PART'; productTypes: TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS['data'] }
    | { masterName: 'STYLE_NO'; productTypes: TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS['data'] };
};

export type TREQUEST_ADD_NEW_PRODUCT_TYPE_MASTER = {
  name: string;
  description?: string;
};

export type TREQUEST_ADD_NEW_OPERATION_MASTER = {
  name: string;
  productTypeId: string;
  description?: string;
};

export type TREQUEST_ADD_NEW_PART_MASTER = {
  name: string;
  productTypeId: string;
  description?: string;
};

export type TREQUEST_ADD_NEW_STYLE_MASTER = {
  styleNo: string;
  productTypeId: string;
  description?: string;
};

export type TREQUEST_ADD_NEW_MACHINE_MASTER = {
  name: string;
  allowancePercent: number;
  description?: string;
};

export type TREQUEST_ADD_NEW_FATIGUE_ALLOWANCES_MASTER = {
  name: string;
  valuePercent: number;
};

export type TREQUEST_E8_MASTER_LISTING = {
  page: number;
  itemsPerPage: number;
  searchStr?: string;
  selectedFilters?: TFilterSelected[];
  sort?: TSortingParameter;
};

type TWrapperMasterSearchResponse<T> = {
  data: T[];
  paginationInfo: TPaginationInfo;
  filters?: TFilterSelected[];
  sortingOptions?: TSortingParameter[];
};

export type TRESPONSE_PRODUCT_TYPE_MASTER = TWrapperMasterSearchResponse<{
  id: string;
  code: string;
  name: string;
  description?: string;
  inUse: boolean;
}>;
export type TRESPONSE_OPERATION_MASTER = TWrapperMasterSearchResponse<{
  id: string;
  code: string;
  name: string;
  description?: string;
  productTypeId: string;
  productTypeName: string;
  inUse: boolean;
}>;
export type TRESPONSE_PART_MASTER = TWrapperMasterSearchResponse<{
  id: string;
  code: string;
  name: string;
  description?: string;
  productTypeId: string;
  productTypeName: string;
  inUse: boolean;
}>;
export type TRESPONSE_STYLE_MASTER = TWrapperMasterSearchResponse<{
  id: string;
  code: string;
  styleNo: string;
  description?: string;
  productTypeId: string;
  productTypeName: string;
  inUse: boolean;
}>;
export type TRESPONSE_MACHINE_MASTER = TWrapperMasterSearchResponse<{
  id: string;
  code: string;
  name: string;
  allowancePercent: number;
  description?: string;
  inUse: boolean;
}>;

export type TREQUEST_SEARCH_FATIGUE_ALLOWANCE_MASTER = TREQUEST_E8_MASTER_LISTING;
export type TRESPONSE_FATIGUE_ALLOWANCE_MASTER = TWrapperMasterSearchResponse<{
  id: string;
  name: string;
  valuePercent: number;
  version: number;
}>;

export type TREQUEST_UPDATE_FATIGUE_ALLOWANCE_MASTER = {
  id: string;
  name: string;
  valuePercent: number;
};

export type TREQUEST_UPDATE_BUNDLE_ALLOWANCE_MASTER = {
  valuePercent: number;
};
export type TRESPONSE_BUNDLE_ALLOWANCE_MASTER = {
  data: {
    id: string;
    valuePercent: number;
    version: number;
  };
};
